import { journal } from '@/server-data'

export const useJournal = () => journal
